import { ReactComponent as LogoPlaceholder } from '@assets/icons/logo-placeholder.svg';
import { Box } from '@mui/material';

export type LogoProps = {
  logo?: string;
  size?: number | string;
};

/** The circle's diameter when the caller does not override `size`. */
const DEFAULT_SIZE = 34;

const Logo = ({ logo, size = DEFAULT_SIZE }: LogoProps) => (
  <Box
    sx={{
      width: size,
      height: size,
      flexShrink: 0,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: '50%',
      textTransform: 'uppercase',
      '& > svg, & > img': {
        width: '100%',
        height: '100%',
        borderRadius: '50%',
        objectFit: 'contain',
      },
      // An uploaded logo is usually transparent or light-on-white; the white
      // backing keeps it legible on any row background.
      '& > img': { backgroundColor: 'common.white' },
    }}
  >
    {logo ? <img src={logo} alt='' /> : <LogoPlaceholder />}
  </Box>
);

export default Logo;
